export enum WeightUnit {
  GRAM = 'grams',
  POUND = 'lb',
}
